(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("ngSanitize"));
	else if(typeof define === 'function' && define.amd)
		define(["angular", "ngSanitize"], factory);
	else if(typeof exports === 'object')
		exports["CSMCommonWeb"] = factory(require("angular"), require("ngSanitize"));
	else
		root["CSMCommonWeb"] = factory(root["angular"], root["ngSanitize"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5526__, __WEBPACK_EXTERNAL_MODULE__2475__) => {
return 